import { render, staticRenderFns } from "./TermsView.vue?vue&type=template&id=01782f6b&"
import script from "./TermsView.vue?vue&type=script&lang=ts&"
export * from "./TermsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports